import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import useAllocationUtilityStyles from 'src/pages/AllocationTablesPage/AllocationUtility/styles';
import FinancialTextInput from 'src/components/shared/FinancialTextInput';
import { useDelay } from 'src/utils/hooks';
import useFSEBillContentStyles from './styles';
const InputCell = _ref => {
  let amountData = _ref.amountData,
    id = _ref.id,
    updateAmount = _ref.updateAmount,
    updateFSE = _ref.updateFSE;
  const classes = useAllocationUtilityStyles();
  const fseBillClasses = useFSEBillContentStyles();
  const _useState = useState(amountData || 0),
    _useState2 = _slicedToArray(_useState, 2),
    amount = _useState2[0],
    setAmount = _useState2[1];
  useDelay(() => {
    updateAmount(id, amount);
    updateFSE();
  }, [amount], 1000);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.overflowCellWrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.cellContent, " ").concat(fseBillClasses.cellInput)
  }, /*#__PURE__*/React.createElement(FinancialTextInput, {
    handleInputChange: val => setAmount(val),
    valueExt: amountData,
    withAdorment: true
  })));
};
export default InputCell;